import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import Menu from "./pages/Menu";
import InfoPage from "./pages/Info";
import CookiePolicy from "./pages/CookiePolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdminLogin from "./pages/admin/Login";
import AdminSettings from "./pages/admin/Settings";
import AdminMenuEditor from "./pages/admin/MenuEditor";
import BottomTabs from "./components/BottomTabs";
import CookieNotice from "./components/CookieNotice";

const TAB_ROUTES = ["/", "/menu", "/info"];

function Shell() {
  const location = useLocation();
  const isTabRoute = TAB_ROUTES.includes(location.pathname);

  return (
    <div className="app-shell">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/info" element={<InfoPage />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/menu" element={<AdminMenuEditor />} />
        <Route path="*" element={<Home />} />
      </Routes>

      {isTabRoute && <BottomTabs />}
      <CookieNotice withTabBar={isTabRoute} />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
